




















import { Component, Vue, Prop } from 'vue-property-decorator'
import router from '../router'

@Component
export default class ResetPassword extends Vue {
  @Prop({ default: '' }) readonly type!: string

  form = {
    password: '',
    confirmPassword: ''
  }

  rules = {
    password: [{ validator: this.validatePass, trigger: 'change' }],
    confirmPassword: [{ validator: this.validatePass2, trigger: 'change' }],
  }

  loading: boolean = false

  $refs!: {
    form: HTMLFormElement
  }

  validatePass(rule: any, value: string, callback: any) {
    if (value === '') {
      callback(new Error('Please enter your new password'))
    } else {
      if (this.form.confirmPassword !== '') {
        this.$refs.form.validateField('confirmPassword')
      }
      callback();
    }
  }

  validatePass2(rule: any, value: string, callback: any)  {
    if (value === '') {
      callback(new Error('Please re-enter your password again'))
    } else if (value !== this.form.password) {
      callback(new Error("The password is not match!"))
    } else {
      callback();
    }
  }

  submit() {
    if (this.form.password && this.form.password === this.form.confirmPassword) {
      let type = ''
      this.loading = true
      if (this.type === 'verify') {
        type = 'verifyEmail'
      }
      else if (this.type === 'resetPassword') {
        type = 'resetPassword'
      }
      this.$store.dispatch(type, {
        password: this.form.password,
        token: this.$route.params.code
      }).then(() => {
        this.loading = false
        router.push({name: 'Login'})
      })
    }
  }

}
